import { Redirect } from 'react-router-dom'
import { componentResolver } from '../../components'
import { resolveSignUpPage } from './resolveSignUpPage'

export const SignUpPage = /*@__PURE__*/ componentResolver(resolveSignUpPage, () => (
	<Redirect to={{ pathname: '/', search: '?view=signup' }} />
))
